module.exports = __webpack_public_path__ + "static/media/cultural.109e1bfe.jpg";